var $c64f4db9c44aed5b$exports = {};
$c64f4db9c44aed5b$exports = {
    "collapse": `R\xe9duire`,
    "expand": `D\xe9velopper`
};


export {$c64f4db9c44aed5b$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
